import React, {Component} from 'react';
import * as func from "../../../../../../utils/functions";
import MPIntroduceEduItem from "./item";
import {EDIT_MODE} from "../../../../../../wpconfig";

class MPIntroduceEdu extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isInit: false,
			career_data: this.props.career_data,
			editIndex: '',
			pkKey: 'scholar_career_id',
			categoryType: 'scholar_edu_kind',
			scholar_kind: [],
			scholar_kind_Name: [],
		}
	}

	componentDidMount() {
		func.getData("code/search/" + this.state.categoryType, {}).then((response) => {
			const t = {}
			t.isInit = true;
			t.scholar_kind = response.records;
			t[this.state.categoryType + "_Name"] = {}
			response.records.map((r, i) => {
				t[this.state.categoryType + "_Name"][r.code_id] = r.code_name;
			});
			this.setState(t);
		});

		this.onInsert = this.onInsert.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onRemove = this.onRemove.bind(this);
		this.onEditIndex = this.onEditIndex.bind(this);
	}

	onInsert() {
		const record = this.state.career_data;

		if (record.length > 0 && record[0][this.state.pkKey] === '') {
			// this.showMessage('추가해주세요.')
		} else {
			const insertRecord = {
				"career_type": "edu",
				"career_kind": "",
				"career_org": "",
				"start_yyyymm": "",
				"end_yyyymm": "",
				"career_role": "",
				"open_yn": "Y",
				"scholar_id": "",
				"scholar_career_id": "",
				"is_edit": EDIT_MODE.SHOW_EDIT,
			}
			this.onEditIndex(0);
			// 데이터 변환 체크하기
			record.unshift(insertRecord)
			this.setState({career_data: record})
		}
	}

	onUpdate(index, item, render) {
		const record = this.state.career_data
		record[index] = item
		this.setState({career_data: record})
		if (render)
			this.forceUpdate();
	}

	onRemove(index) {
		const record = this.state.career_data
		record.splice(index, 1);
		this.setState({career_data: record})
		this.forceUpdate();
	}

	onEditIndex(id) {
		if(this.state.editIndex === id)
			return '';
		if (this.state.editIndex)
			this.refs["ref" + this.state.editIndex].onClose();
		else if (this.refs.ref)
			this.refs.ref.onClose();
		else if (this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();

		this.setState({
			'editIndex': id
		})
	}

	render() {
		if (!this.state.isInit)
			return ''

		return (
			<div className="mt-4 pt-4 border-top border-lightgray">
				<div>
					<div className="d-inline-block">학력</div>
					<button type="button" className="icon icon-size-24 icon-plus-black pl-0 pr-0 flex-auto float-right"
					onClick={this.onInsert} />
				</div>
				<div className="mt-px-10">
					<div>
						{this.state.career_data.map((data, idx) => {
							return (
								<MPIntroduceEduItem
									key={data[this.state.pkKey]}
									index={data[this.state.pkKey]}
									ref={"ref" + data[this.state.pkKey]}
									pkKey={this.state.pkKey}
									arrIndex={idx}
									record={data}
									scholar_kind={this.state.scholar_kind}
									scholar_kind_Name={this.state.scholar_kind_Name}
									onUpdate={this.onUpdate}
									onRemove={this.onRemove}
									onEditIndex={this.onEditIndex}
								/>
							)
						})}
					</div>
				</div>
			</div>
		)
	}
};

export default MPIntroduceEdu;
